<template>
  <div id="result-panel">
    <div id="article-tags" class="mb20">
      <label>{{ $t("article") }}</label>

      <app-article-mentions
        v-if="!!briefMappings.data"
        :mentions="articleMentions"
        :activeOrganization="activeOrganization"
        :keysPressed="keysPressed"
        @deleteMentionTag="callDeleteMentionTag"
        @deleteRelationMentionTag="$emit('deleteRelationMentionTag', $event)"
        @updateMentionSentiment="$emit('updateMentionSentiment', $event)"
        @toggleCategories="toggleCategories"
        @recordAction="$emit('recordAction', $event)"
        @showRelationTagMenu="$emit('showRelationTagMenu', $event)"
      />
    </div>
    <div id="content-tags">
      <label>{{ $t("content") }}</label>
      <button
        v-tooltip="$tc('organization', 2)"
        class="icon-btn icon-organizations click-outside-categories-ignore"
        @click="toggleOrganizations"
        @keydown.enter.prevent
      >
        <i class="fas fa-building"></i>
      </button>
      <button
        v-tooltip="$tc('category', 2)"
        class="icon-btn icon-categories click-outside-categories-ignore"
        @click="() => toggleCategories(false)"
        @keydown.enter.prevent
      >
        <i class="fas fa-bars"></i>
      </button>

      <app-content-mentions
        :mentions="contentMentions"
        :activeOrganization="activeOrganization"
        :keysPressed="keysPressed"
        @setActiveOrganization="$emit('setActiveOrganization', $event)"
        @deleteMentionTag="callDeleteMentionTag"
        @deleteOrganizationMention="$emit('deleteOrganizationMention', $event)"
        @deleteRelationMentionTag="$emit('deleteRelationMentionTag', $event)"
        @updateMentionSentiment="$emit('updateMentionSentiment', $event)"
        @toggleCategories="toggleCategories"
        @recordAction="$emit('recordAction', $event)"
        @showRelationTagMenu="$emit('showRelationTagMenu', $event)"
        @cloneOrganizationMentions="$emit('cloneOrganizationMentions', $event)"
      />
    </div>
  </div>
</template>

<script>
  import ArticleMentions from './article_mentions';
  import ContentMentions from './content_mentions';

export default {
  props: {
    articleMentions: {
      type: Array,
      required: true
    },
    contentMentions: {
      type: Array,
      required: true
    },
    activeOrganization: String,
    briefMappings: Object,
    keysPressed: {
      type: Array,
      required: true
    }
  },
  components: {
    'app-article-mentions': ArticleMentions,
    'app-content-mentions': ContentMentions
  },
  methods: {
    callDeleteMentionTag({ tag, organization }) {
      this.$emit('deleteMentionTag', { tag, organization });
    },
    toggleOrganizations () {
      this.$emit('toggleOrganizationsTagMenu');
    },
    toggleCategories (overflow, category) {
      this.$emit('toggleCategoriesTagMenu', overflow, category);
    }
  }
}
</script>
